import React, { Component } from 'react'
import { Field } from 'redux-form'
import { renderTextField } from '../../../Forms/fieldRenderers'
import { required, getNumericValidator } from '../../../Forms/fieldValidators'
import { EntityAutocomplete, CerealVariedadDropdown } from '../../../Forms/SharedComponents/containers'
import { Row, Col } from 'react-bootstrap'
import { Button, CircularProgress } from '@material-ui/core'
const numerico5 = getNumericValidator(1, 5)
const numeric8 = getNumericValidator(1, 8)
const telefono = getNumericValidator(10, 12)
const numeric12 = getNumericValidator(11, 12)

class CamposIngresoMinimo extends Component {
  render () {
    const {
      onSubmit,
      onCpaChange,
      bloqueado,
      updateByPresunta,
      procesandoCPA,
      invalid
    } = this.props

    // console.log('updateByPresunta', updateByPresunta)

    return (
      <div className='wrapperIngresoMinimo'>
        <h2 >
          Ingreso a Playa de Camiones
        </h2>
        <Row style={{ justifyContent: 'center' }}>
          <Col md={8}>
            <Field
              className='cpa'
              name='numero'
              type='text'
              label='Nº de CTG en CPE Electrónica'
              component={renderTextField}
              autoFocus
              validate={[required, numeric12]}
              placeholder='10201000000'
              onChange={onCpaChange}
            />
          </Col>
        </Row>
        {procesandoCPA && <div style={{ padding: '10% 0', margin: '0 auto' }} >
          <CircularProgress thickness='5' size='5rem' />
          <h4 style={{ margin: '15px ', fontSize: '1.3rem' }}>Por favor aguarde...</h4>
        </div>}
        {updateByPresunta &&
        <>
          <Row>
            <Col md={12}>
              <CerealVariedadDropdown disabledCereal={bloqueado} disabledVariedad={false} />
            </Col>
          </Row>
          <fieldset disabled={bloqueado}>
            <Row>
              <Col md={3}>
                <Field
                  name='cpeSucursal'
                  type='text'
                  label='Nº Sucursal CPE'
                  component={renderTextField}
                  autoFocus={false}
                  validate={[required, numerico5]}
                  placeholder='00001'
                  disabled={bloqueado}
                />
              </Col>
              <Col md={3}>
                <Field
                  name='cpeSecuencia'
                  type='text'
                  label='Nº de Orden CPE'
                  component={renderTextField}
                  autoFocus={false}
                  validate={[required, numeric8]}
                  placeholder='00000025'
                  disabled={bloqueado}
                />
              </Col>
              <Col md={2}>
                <Field
                  name='camion'
                  label='Camión'
                  type='text'
                  component={renderTextField}
                  validate={[required]}
                  placeholder='AA123AA'
                />
              </Col>
              <Col md={2}>
                <Field
                  name='pesoBruto'
                  type='text'
                  label='Kgs Bruto'
                  component={renderTextField}
                  autoFocus={false}
                />
              </Col>
              <Col md={2}>
                <Field
                  name='pesoTara'
                  type='text'
                  label='Kgs Tara'
                  component={renderTextField}
                  autoFocus={false}
                />
              </Col>
            </Row>
            <Row>
              <Col md={6}>
                <EntityAutocomplete
                  name='exportador'
                  label='Destinatario'
                  entity='exportador'
                  placeholder='Exportador - 19999999991'
                />
              </Col>
              <Col md={6}>
                <EntityAutocomplete
                  name='titular'
                  required={false}
                  label='Titular de Carta de Porte'
                  entity='cargador'
                  placeholder='Titular - 19999999991'
                />
              </Col>
            </Row>
            <Row>
              <Col md={6}>
                <EntityAutocomplete
                  name='remitenteComercialProductor'
                  required={false}
                  label='Remitente Comercial Productor'
                  entity='cargador'
                  placeholder='Remitente - 19999999991'
                />
              </Col>
              <Col md={6}>
                <EntityAutocomplete
                  name='remitenteComercialVentaPrimaria'
                  required={false}
                  label='Remitente Comercial Venta Primaria'
                  entity='cargador'
                  placeholder='Remitente - 19999999991'
                />
              </Col>
              <Col md={6}>
                <EntityAutocomplete
                  name='remitenteComercialVentaSecundaria'
                  required={false}
                  label='Remitente Comercial Venta Secundaria'
                  entity='cargador'
                  placeholder='Remitente - 19999999991'
                />
              </Col>
              <Col md={6}>
                <EntityAutocomplete
                  name='intermediario'
                  required={false}
                  label='Remitente Comercial Venta Secundaria 2'
                  entity='cargador'
                  placeholder='Remitente - 19999999991'
                />
              </Col>
            </Row>
            <Row>
              <Col md={6}>
                <EntityAutocomplete
                  name='corredorComprador'
                  label='Corredor Venta Primaria'
                  entity='corredor'
                  placeholder='Corr. Venta Primaria - 19999999991'
                />
              </Col>
              <Col md={6}>
                <EntityAutocomplete
                  name='corredorVendedor'
                  label='Corredor Venta Secundaria'
                  entity='corredor'
                  placeholder='Corr. Venta Secundaria - 19999999991'
                />
              </Col>
            </Row>
            <Row>
              <Col md={6}>
                <EntityAutocomplete
                  name='vendedor'
                  label='Representante Entregador'
                  entity='vendedor'
                  placeholder='Entregador - 19999999991'
                />
              </Col>
              <Col md={6}>
                <EntityAutocomplete
                  name='chofer'
                  label='Chofer'
                  entity='chofer'
                  placeholder='Chofer - 19999999991'
                  disabled={bloqueado}
                />
              </Col>
            </Row>
            <Row>
              <Col md={12}>
                <Field
                  name='observacion'
                  type='text'
                  label='Observaciones'
                  component={renderTextField}
                />
              </Col>
            </Row>
          </fieldset>
          <Row>
            <Col md={3}>
              <Field
                name='telefonoChofer'
                type='text'
                label='Teléfono Móvil Chofer'
                component={renderTextField}
                validate={[required, telefono]}
                placeholder='2262330101'
              />
            </Col>
          </Row>
          <Row className='d-flex align-items-center justify-content-center'>
            <Button
              onClick={onSubmit}
              disabled={invalid}
              size='medium'
              variant='contained'
              color='primary'
            >Confirmar Ingreso</Button>
          </Row>
        </>}
        <br />
      </div>
    )
  }
}

export default CamposIngresoMinimo
